/**
 * en-GB messages for the tabbed Platform > Settings page (branch p5/platform-tabs).
 * Flat keys, merged into enGB by ./index.ts.
 */
export const platformTabsEnGB = {
    'platformTabs.label': 'Platform settings sections',
    'platformTabs.general': 'General',
    'platformTabs.general.desc': 'Public link limits and when background tasks run.',
    'platformTabs.security': 'Sign-in and security',
    'platformTabs.security.desc': 'Password and session rules, support access and Microsoft sign-in.',
    'platformTabs.email': 'Email',
    'platformTabs.email.desc': 'The sender address and the mail server CloudSign sends through.',
    'platformTabs.sms': 'Text messages',
    'platformTabs.sms.desc': 'The BulkSMS account used to send text messages.',
    'platformTabs.wallet': 'Google Wallet',
    'platformTabs.wallet.desc': 'The Google Wallet issuer account shared by every customer.',
    'platformTabs.apps': 'Phone apps',
    'platformTabs.apps.desc': 'Where people download the apps, and the push notification token.',
    'platformTabs.data': 'Domains and data',
    'platformTabs.data.desc': 'Customer domains, closing a customer account and file uploads.',
    'platformTabs.advanced': 'Advanced',
    'platformTabs.advanced.desc': 'Live updates, background jobs and API limits. Change these only if you know why.',
    'platformTabs.entra.title': 'Microsoft Entra app',
    'platformTabs.entra.description': 'The client ID is set above. The client secret is write-only and is never shown again.',
    'platformTabs.expo.title': 'Push notifications',
    'platformTabs.expo.description': 'The Expo access token used to send push notifications to the phone apps.',
};
//# sourceMappingURL=platform-tabs.js.map